import React, { useEffect, useState } from 'react';
import { Breadcrumbs, Menu, MenuItem } from '@mui/material';
import { Modal } from 'antd';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { AiOutlineFileImage } from 'react-icons/ai';
import { FaFileUpload, FaFolderPlus } from 'react-icons/fa';
import { GoKebabVertical } from 'react-icons/go';
import { HiFolder } from 'react-icons/hi';
import Collapse from '@mui/material/Collapse';
import {
  addRepositoryElement,
  deleteRepositoryElement,
  downloadFileOrFolder,
  getSubRepositoryList,
  renameRepositoryElement,
  repositoryList,
} from '../../Services/Utils/DataRepositoryApis';
import { notifySet } from '../../Services/Actions/CommonActions';
import { uploadImages } from '../../Services/Utils/CommonApis';
import { getImage } from '../../Services/Utils/FileApis';
import ClipboardCopy from '../../components/ServiceProvider/ClipboardCopy';
import MultiFileUpload from '../../common/MultiFileUpload';

function DataRepositoryList() {
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const [element, setElements] = useState([]);
  const [currentElement, setCurrentElement] = useState();
  const [currentBreadCrumbs, setCurrentBreadCrumbs] = useState([]);
  const [currentElementForAction, setCurrentElementForAction] = useState();
  const [folderName, setFolderName] = useState('');
  const [folderModal, setFolderModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [renameModal, setRenameModal] = useState(false);
  const [shareModal, setShareModal] = useState(false);

  useEffect(() => {
    const parentId = searchParams.get('uuid');
    if (parentId !== null) {
      getSubElements({ uuid: parentId });
    } else {
      getRootElements();
    }
  }, []);

  const getRootElements = async () => {
    const params = { start: 0, recordSize: '' };
    await repositoryList({}, params).then((res) => {
      setElements(res.list);
      setCurrentBreadCrumbs([{ name: 'Home', id: 0, path: '' }]);
      setCurrentElement({ name: 'Home', id: 0, path: '' });
      setSearchParams();
    });
  };

  const getSubElements = async (row) => {
    const params = { uuid: row?.uuid };
    breadCrumbs = [];
    await getSubRepositoryList(params).then((res) => {
      setElements(res.view.subDataRepositoryViews);
      searchParams.set('uuid', row?.uuid);
      setSearchParams(searchParams);
      breadCrumbs.push(res.view);
      saveBreadCrumbs(res.view);
      breadCrumbs.reverse();
      setCurrentBreadCrumbs(breadCrumbs);
      setCurrentElement(res.view);
    });
  };

  // breadcrumbs
  let breadCrumbs = [];
  const saveBreadCrumbs = (response) => {
    if (response.hasOwnProperty('parentDataRepositoryView')) {
      breadCrumbs.push(response.parentDataRepositoryView);
      saveBreadCrumbs(response.parentDataRepositoryView);
    } else {
      breadCrumbs.push({ name: 'Home', id: 0, path: '' });
    }
  };

  const callList = () => {
    if (currentElement?.id === 0) {
      getRootElements();
    } else {
      getSubElements(currentElement);
    }
  };

  // onclick element
  const handleClickElement = async (data) => {
    if (data.type === 'folder') {
      setCurrentElement(data);
      await getSubElements(data);
      breadCrumbs.push(data);
      setCurrentBreadCrumbs([...currentBreadCrumbs, data]);
    } else {
      window.location.href = getImage(data.fileView);
    }
  };

  // add folder
  const handleAddFolder = () => {
    const data = {
      type: 'folder',
      name: folderName,
      parentDataRepositoryView: {
        uuid: currentElement?.uuid,
      },
    };
    addRepositoryElement(data).then((res) => {
      const { message, hasError } = res;
      if (hasError === false) {
        setFolderModal(false);
        setFolderName('');
        dispatch(notifySet({ type: 'success', message }));
        callList();
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  // add file
  let count = 0;
  const [fileList, setFileList] = useState([]);
  const onChange = (info) => {
    uploadImages({ file: info.file }).then((res) => {
      if (res.hasError === false) {
        const data = {
          type: 'file',
          fileView: {
            fileId: res.view.fileId,
          },
          name: res.view.originalName,
          parentDataRepositoryView: {
            uuid: currentElement?.uuid,
          },
        };
        addRepositoryElement(data).then((resp) => {
          const { message, hasError } = resp;
          if (hasError === false) {
            dispatch(notifySet({ type: 'success', message }));
            count += info.fileList.length;
            if ( count / info.fileList.length === info.fileList.length) {
              callList();
              setFileList([]);
            }
          } else {
            dispatch(notifySet({ type: 'error', message }));
          }
        });
      }
    });
  };

  // more actions
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (e, data) => {
    e.preventDefault();
    setAnchorEl(e.currentTarget);
    setCurrentElementForAction(data);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // Breadcrumbs path
  async function handleClickforBreadCums(row) {
    setCurrentElement(row);
    if (row.id !== currentElement.id) {
      if (row.id === 0) {
        await getRootElements();
      } else {
        await getSubElements(row);
      }
    }
  }

  // delete element
  const handleDelete = () => {
    const param = { uuid: currentElementForAction?.uuid };
    deleteRepositoryElement(param).then((res) => {
      const { message, hasError } = res;
      if (hasError === false) {
        setDeleteModal(false);
        dispatch(notifySet({ type: 'success', message }));
        callList();
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  // rename element
  const handleRenameElement = () => {
    const data = {
      uuid: currentElementForAction.uuid,
      name: folderName,
    };
    renameRepositoryElement(data).then((res) => {
      const { message, hasError } = res;
      if (hasError === false) {
        setRenameModal(false);
        dispatch(notifySet({ type: 'success', message }));
        callList();
      } else {
        dispatch(notifySet({ type: 'error', message }));
      }
    });
  };

  return (
    <>
      <h6 style={{ userSelect: 'none' }}>Data Repository</h6>
      <div className="row col-12">
        <div
          className="col-sm-10"
          style={{ margin: '20px 0px' }}
        >
          <Breadcrumbs
            sx={{ userSelect: 'none' }}
            aria-label="breadcrumb"
          >
            {currentBreadCrumbs.map((row, k) => (
              <span
                onClick={() => handleClickforBreadCums(row)}
                key={k}
                style={{ cursor: 'pointer' }}
              >
                {row.name}
              </span>
            ))}
          </Breadcrumbs>
        </div>
        <div
          className="col-sm-2"
          style={{ textAlign: 'right' }}
        >
          <MultiFileUpload onChange={onChange} fileList={fileList}>
            <FaFileUpload
              className="addcircle"
              title="Upload a file"
              style={{
                fontSize: '35px',
                padding: '6px',
                cursor: 'pointer',
                marginRight: '10px',
              }}
            />
          </MultiFileUpload>
          <FaFolderPlus
            className="addcircle btn-primary"
            title="Create a folder"
            style={{
              fontSize: '35px',
              padding: '6px',
              cursor: 'pointer',
            }}
            onClick={() => setFolderModal(true)}
          />
        </div>
      </div>
      <div style={{ marginTop: '40px' }}>
        {element.length === 0 && <h6>No file or folder found</h6>}
        {element?.map((data, k) => (
          <div
            className="element-items"
            onDoubleClick={() => handleClickElement(data)}
            key={k}
          >
            <span>
              {data.type === 'folder' ? (
                <HiFolder style={{ fontSize: '45px' }} />
              ) : (
                <AiOutlineFileImage style={{ fontSize: '45px', padding: '2px' }} />
              )}
              <span
                style={{ fontSize: '20px', marginLeft: '10px', userSelect: 'none' }}
              >
                {data.name}
              </span>
              <span
                onClick={(e) => handleClick(e, data)}
                style={{ float: 'right' }}
              >
                <GoKebabVertical
                  title="more actions"
                  className="menu-item-button"
                />
              </span>
            </span>
          </div>
        ))}
        <Menu
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Collapse}
        >
          <MenuItem
            onClick={() => {
              setRenameModal(true);
              setFolderName(currentElementForAction.name);
              setAnchorEl(null);
            }}
          >
            Rename
          </MenuItem>
          <MenuItem
            onClick={() => {
              setDeleteModal(true);
              setAnchorEl(null);
            }}
          >
            Delete
          </MenuItem>
          <MenuItem
            onClick={() => {
              downloadFileOrFolder({ uuid: currentElementForAction?.uuid });
              // window.location.href = getImage(currentElementForAction.fileView);
              setAnchorEl(null);
            }}
          >
            Download
          </MenuItem>
          {currentElementForAction?.type !== 'folder' && (
            <MenuItem
              onClick={() => {
                setShareModal(true);
                setAnchorEl(null);
              }}
            >
              Share
            </MenuItem>
          )}
        </Menu>
      </div>
      <Modal
        centered
        open={folderModal}
        onOk={handleAddFolder}
        onCancel={() => {
          setFolderModal(false);
          setFolderName('');
        }}
        okText="Add Folder"
      >
        <h6>Add Folder</h6>
        <input
          className="form-control"
          type="text"
          style={{ height: '43px', margin: '20px 0px' }}
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
        />
      </Modal>
      <Modal
        centered
        open={renameModal}
        onOk={handleRenameElement}
        onCancel={() => {
          setRenameModal(false);
          setFolderName('');
        }}
        okText="Update"
      >
        <h6>Rename {currentElementForAction?.type}</h6>
        <input
          className="form-control"
          type="text"
          style={{ height: '43px', margin: '20px 0px' }}
          value={folderName}
          onChange={(e) => setFolderName(e.target.value)}
        />
      </Modal>
      <Modal
        centered
        open={deleteModal}
        onOk={handleDelete}
        onCancel={() => {
          setDeleteModal(false);
        }}
        okText="Delete"
        okButtonProps={{ style: { background: '#EA3732' } }}
      >
        <p>Are you sure you want to delete this {currentElementForAction?.type} ?</p>
        <h6>{currentElementForAction?.name}</h6>
      </Modal>
      <Modal
        centered
        open={shareModal}
        onCancel={() => {
          setShareModal(false);
        }}
        footer={null}
      >
        <p>Share</p>
        <ClipboardCopy customStyles={{ margin: '30px 0px' }} copyText={getImage(currentElementForAction?.fileView)} />
      </Modal>
    </>
  );
}

export default DataRepositoryList;
